import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { CAMPAIGN_FORM_ID, CAMPAIGN_FORM_KEYS } from '../../constants';

const valueSelector = formValueSelector(CAMPAIGN_FORM_ID);
const mapStateToProps = state => {
    const activeProps = valueSelector(
        state,
        CAMPAIGN_FORM_KEYS.ACTIVE,
        CAMPAIGN_FORM_KEYS.START_DATE,
        CAMPAIGN_FORM_KEYS.END_DATE
    );
    return {
        active: activeProps[CAMPAIGN_FORM_KEYS.ACTIVE],
        startDate: activeProps[CAMPAIGN_FORM_KEYS.START_DATE],
        endDate: activeProps[CAMPAIGN_FORM_KEYS.END_DATE]
    };
};

export default connect(mapStateToProps);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withActiveFormProps.js
 **/